import type { Heading } from '@ps/web-martech-cms-types';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { CMSLink } from '@swf/cms';

import useAuthenticatedContent from '../../hooks/useAuthenticatedContent';

import styles from './CMSHeading.scss';

export interface Props extends Heading {
  className?: string;
}

const CMSHeading: React.FC<Heading & Partial<ClassNameProp> & { logged_in_title?: string }> = ({
  level = 'h1',
  title,
  url,
  target,
  rel,
  alignment,
  anchor,
  className,
  size,
  hero,
  logged_in_title: loggedInTitle
}) => {
  const headingTitle = useAuthenticatedContent(title, loggedInTitle);

  if (!headingTitle) {
    return null;
  }

  const getSize = (element: string) => {
    switch (element) {
      case 'h1':
        return 'l';
      case 'h2':
        return 'm';
      case 'h3':
        return 's';
      default:
        return 'xs';
    }
  };
  const El = level || 'h1';
  const headingClassName = `${size || getSize(level as string)}${
    hero ? 'Hero' : ''
  }` as keyof typeof styles;

  return (
    <El
      id={anchor}
      className={classNames(styles[headingClassName], className, alignment && styles[alignment])}
    >
      {url ? (
        <CMSLink
          url={url}
          className={styles.link}
          title={headingTitle}
          target={target ?? '_self'}
          rel={rel}
        />
      ) : (
        headingTitle
      )}
    </El>
  );
};

export default CMSHeading;
